import { FC } from 'react'
import { ShippedMonthCell } from './ShippedMonthCell'
import { PlannedMonthCell } from './PlannedMonthCell'
import { isPreviousMonth } from '@/core/utils/isPreviousMonth.ts'
import { Product } from '@/data/replenishmentPlan/slice/replenishmentPlan.types.ts'
import { isCurrentMonth } from '@/core/utils/isCurrentMonth.ts'

interface Props {
  date: Date
  product: Product
}

const PlanTableCell: FC<Props> = ({ date, product }) => {
  const isPreviousOrCurrent = isPreviousMonth(date) || isCurrentMonth(date)

  return isPreviousOrCurrent || !product.isInPlan ? (
    <ShippedMonthCell date={date} product={product} />
  ) : (
    <PlannedMonthCell date={date} product={product} />
  )
}

export default PlanTableCell
